import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the users state domain
 */

const selectUsersDomain = state => state.users || initialState;

/**
 * Other specific selectors
 */

const makeSelectLoading = () =>
  createSelector(
    selectUsersDomain,
    substate => substate.loading,
  );

const makeSelectError = () =>
  createSelector(
    selectUsersDomain,
    substate => substate.error,
  );

const makeSelectId = () =>
  createSelector(
    selectUsersDomain,
    substate => substate.id,
  );

const makeSelectFirstRender = () =>
  createSelector(
    selectUsersDomain,
    substate => substate.firstRender,
  );

const makeSelectUsersList = () =>
  createSelector(
    selectUsersDomain,
    substate => substate.usersList,
  );

const makeSelectUsersListFirstElem = () =>
  createSelector(
    selectUsersDomain,
    substate => substate.firstElem,
    );

const makeSelectUser = () =>
  createSelector(
    selectUsersDomain,
    substate => substate.userDetail,
      );
    
/**
 * Default selector used by Users
 */

const makeSelectUsers = () =>
  createSelector(
    selectUsersDomain,
    substate => substate,
  );

export default makeSelectUsers;
export {
  selectUsersDomain,
  makeSelectId,
  makeSelectFirstRender,
  makeSelectLoading,
  makeSelectError,
  makeSelectUsersList,
  makeSelectUser,
  makeSelectUsersListFirstElem,
};
